import axios from "axios"

const CMS_URL = "http://jit.adamwolny.pl/wp-json/wp/v2/"

export const CMSAPIService = axios.create({
  baseURL: CMS_URL,
  headers: {
    "Content-Type": "application/json",
  },
})

CMSAPIService.interceptors.request.use(
    async config => {
      config.baseURL = CMS_URL
      return config
    },
    error => {
      console.log(error.data)
      // eslint-disable-next-line no-undef
      Promise.reject(error)
    },
)

CMSAPIService.interceptors.response.use(
    async response => {
      return {
        items: response.data,
        totalPages: response.headers["x-wp-totalpages"],
      }
    },
    async error => {
      // eslint-disable-next-line no-undef
      return Promise.reject(error)
    },
)

const getHomeArticles = () => CMSAPIService.get(`/articles?page=1&per_page=6`)

const getArticles = (page = 1, perPage = 12) =>
  CMSAPIService.get(`/articles?page=${page}&per_page=${perPage}`)

const getArticleBySlug = (slug: string) => CMSAPIService.get(`/articles?slug=${slug}`)

const getPageBySlug = (slug: string) => CMSAPIService.get(`/pages?slug=${slug}`)

export const CMSService = {
  getArticles,
  getArticleBySlug,
  getPageBySlug,
  getHomeArticles,
}
